// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--N_DZi","icon":"a10a3f92e9--icon--2YTrx"};